document.addEventListener('DOMContentLoaded', () => {
  const slider = document.querySelector('.product__media-list.slider');
  if (!slider) return;

  const isDesktop = () => window.innerWidth >= 749;
  let isDragging = false;
  let startX = 0;
  const threshold = 50; 

  const slides = slider.querySelectorAll('.slider__slide');
  if (!slides.length) return;

  slider.addEventListener('mousedown', (e) => {
    if (!isDesktop()) return;
    isDragging = true;
    startX = e.pageX;
    slider.style.cursor = 'pointer';
    e.preventDefault(); 
  });

  slider.addEventListener('mousemove', (e) => {
    if (!isDragging || !isDesktop()) return;
    e.preventDefault(); 
  });

  slider.addEventListener('mouseup', (e) => {
    if (!isDragging || !isDesktop()) return;
    isDragging = false;
    slider.style.cursor = 'pointer';

    const endX = e.pageX;
    const diffX = startX - endX;

    if (Math.abs(diffX) > threshold) {
      const currentSlide = slider.querySelector('.slider__slide.is-active');
      if (!currentSlide) return;

      const currentIndex = Array.from(slides).indexOf(currentSlide);

      if (diffX > 0) {
        const nextIndex = currentIndex + 1;
        if (nextIndex < slides.length) {
          currentSlide.classList.remove('is-active');
          slides[nextIndex].classList.add('is-active');
          updateSliderPosition(nextIndex);
        }
      } else if (diffX < 0) {
        const prevIndex = currentIndex - 1;
        if (prevIndex >= 0) {
          currentSlide.classList.remove('is-active');
          slides[prevIndex].classList.add('is-active');
          updateSliderPosition(prevIndex);
        }
      }
    }
  });

  slider.addEventListener('mouseleave', () => {
    if (isDragging && isDesktop()) {
      isDragging = false;
      slider.style.cursor = 'grab';
    }
  });

  function updateSliderPosition(index) {
    const slideWidth = slides[0].offsetWidth;
    slider.scrollTo({
      left: slideWidth * index,
      behavior: 'smooth'
    });
  }

  slider.style.cursor = 'grab';
});